export enum DateRangePosition {
  Start = 'start',
  End = 'end',
}
